import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/assets/videos/ml_launch_video.mp4'


const _withScopeId = n => (_pushScopeId("data-v-3dcd9d9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onended"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "video/mp4"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, {
    onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('done'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("video", {
        class: "welcome-video",
        autoplay: "",
        playsinline: "",
        muted: "",
        onended: () => _ctx.$emit('done')
      }, [
        _hoisted_2,
        _createTextVNode(" Your browser does not support the video tag. ")
      ], 8, _hoisted_1)
    ]),
    _: 1
  }))
}